<div *ngIf="isLoading">Loading Chart of Accounts List...</div>

<select *ngIf="!isLoading" [compareWith]="byId" class="form-control" name="chartOfAccounts"
        [(ngModel)]="model.chartOfAccounts" [required]="required">
  <option *ngFor="let accountItem of chartOfAccounts" [ngValue]="accountItem">
    {{ accountItem.name }}
  </option>
</select>
